import { AppState } from "./system/AppState";

const CONNECT_GRACE_PERIOD = 2500;

export class ConnectionStatusOverlay {
  constructor(appState: AppState) {
    const elem = document.createElement("div");
    elem.classList.add("connection-overlay");
    elem.style.position = "absolute";
    elem.style.bottom = "0px";
    elem.style.width = "100%";
    elem.style.fontSize = "12px";
    elem.style.color = "#f65e67";
    elem.style.textTransform = "uppercase";
    elem.style.textAlign = "center";
    elem.style.backgroundColor = "#000";
    elem.style.boxSizing = "border-box";
    elem.style.padding = "4px";
    elem.style.fontFamily = "Nunito Sans";
    elem.style.fontWeight = "800";
    elem.style.paddingBottom = "calc(env(safe-area-inset-bottom) + 4px)";

    // Please see the document CSS-z-index.md
    elem.style.zIndex = "8000";

    //

    const text = "No Internet Connection";
    elem.appendChild(document.createTextNode(text));

    document.body.appendChild(elem);

    appState.onRealTimeConnected.register(() => {
      this.currentlyConnected = true;
      elem.style.display = "none";
    });

    appState.onRealTimeDisconnected.register(() => {
      this.currentlyConnected = false;
      if (!this.inGracePeriod()) {
        elem.style.display = "";
      }
    });

    this.elem = elem;
  }

  private elem: HTMLElement;

  private gracePeriodTimeoutHandle: NodeJS.Timer | null = null;
  private currentlyConnected: boolean = false;

  /**
   * Indicates that the App has just started/resumed, and so a disconnect overlay
   * should not be displayed during a short grace period
   */
  public setConnecting() {
    if (this.gracePeriodTimeoutHandle !== null) {
      clearTimeout(this.gracePeriodTimeoutHandle);
    }
    this.elem.style.display = "none";

    this.gracePeriodTimeoutHandle = setTimeout(() => {
      this.gracePeriodTimeoutHandle = null;
      if (this.currentlyConnected) {
        this.elem.style.display = "none";
      } else {
        this.elem.style.display = "";
      }
    }, CONNECT_GRACE_PERIOD);
  }

  private inGracePeriod(): boolean {
    return this.gracePeriodTimeoutHandle !== null;
  }

  private closed = false;

  public close(): void {
    if (this.closed) {
      throw new Error("ConnectionStatusOverlay already closed");
    }
    this.closed = true;

    document.body.removeChild(this.elem);
  }
}
